import AgentShowRenderer from "~/components/agent/AgentShowRenderer";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { CommandJob } from "~/components/build/Show/lib/types";
import { useReactRouterNavigateHandler } from "~/components/build/Show/lib/useReactRouterNavigateHandler";
import { AgentIcon } from "~/components/job/Job/Agent";
import Spinner from "~/components/shared/Spinner";
import { isTerminalBuildState } from "~/constants/BuildStates";

export function AgentTabLabel({ job }: { job: CommandJob }) {
  const os = job.hosted ? job.instanceShape?.operatingSystem : job.agentOsIconKey;

  return (
    <span className="flex items-center gap-1">
      <AgentIcon os={os} />
      <span>Agent</span>
    </span>
  );
}

export default function AgentTab({ job }: { job: CommandJob }) {
  const { build } = useBuild();
  const org = build.account.slug;
  const linkClickHandler = useReactRouterNavigateHandler();

  if (job.agentUuid) {
    return (
      <div className="py-2.5" onClick={linkClickHandler}>
        <AgentShowRenderer params={{ agent: job.agentUuid, organization: org }} />
      </div>
    );
  }

  if (isTerminalBuildState(build.state)) {
    return (
      <div className="py-2.5">
        <span className="flex items-center gap-2">
          <a
            href={job.agentsPath}
            className="text-inherit hover:text-inherit hover:underline focus:text-inherit"
          >
            {job.clusterQueue?.key ? (
              <>
                No agent connected in queue:&nbsp;
                <span className="font-medium">{job.clusterQueue?.key}</span>
              </>
            ) : (
              <span>No agent connected</span>
            )}
          </a>
        </span>
      </div>
    );
  }

  return (
    <div className="py-2.5">
      <span className="flex items-center gap-2">
        <Spinner color={false} />
        <a
          href={job.agentsPath}
          className="text-inherit hover:text-inherit hover:underline focus:text-inherit"
        >
          {job.clusterQueue?.key ? (
            <>
              Waiting for agent in queue:&nbsp;
              <span className="font-medium">{job.clusterQueue?.key}</span>
            </>
          ) : (
            <span>Waiting for agent</span>
          )}
        </a>
      </span>
    </div>
  );
}
